import { queryOptions, useQuery } from '@tanstack/react-query'
import { getCourses } from '../services/getCourses.service'
import { coursesKeys } from '../constants/courses.queryKeys'
import type { CourseListParams } from '../types/course.types'

export const coursesQueryOptions = (params: CourseListParams = {}) =>
  queryOptions({
    queryKey: coursesKeys.list(params),
    queryFn: () => getCourses(params),
    staleTime: 5 * 60 * 1000,
  })

export function useCourses(params: CourseListParams = {}) {
  return useQuery(coursesQueryOptions(params))
}
